import "@webcomponents/custom-elements";
// @angular/localize/init is loaded from `polyfills` in angular.json (the esbuild builder warns about importing it here).

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { applyDebugMode, installDebugModeShortcut, OveraLogger } from '@overa/shared';

import { AppModule } from './app/app.module';
import { LOGGER_DEFAULTS } from './app/logger.config';
import { environment } from './environments/environment';

// El banner se escribe antes de instalar el logger para que salga siempre,
// también en producción: saber qué versión está cargada no es traza de depuración.
console.info(`--------- ${environment.title} v${environment.version} [${environment.production ? 'production' : 'development'}] ---------`);

// Antes de arrancar Angular, para que las trazas del propio bootstrap ya pasen
// por el filtro. Ver src/app/logger.config.ts; ajustable en caliente desde la
// consola del navegador con `overaLogger.level(...)`.
//
// `applyDebugMode` envuelve los valores por defecto porque en producción la consola está
// silenciada, y este es el único punto lo bastante temprano para recuperarla ante un
// fallo de arranque: corre antes de que Angular exista.
OveraLogger.bootstrap(applyDebugMode(LOGGER_DEFAULTS));

// Ctrl+Alt+Shift+L alterna el modo depuración y recarga; la recarga es la que devuelve la
// atribución de ficheros en DevTools (`captureConsole: "filter"`).
installDebugModeShortcut({ appName: environment.title });

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((error) => {
    // Un fallo aquí deja la app sin arrancar: no hay ErrorHandler todavía, así
    // que se registra el error entero desde el logger.
    OveraLogger.instance.scope('bootstrap').error('No se pudo arrancar la aplicación', error);
  });
